{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "7409af4ecc827d003f96b2228cccfc1facfa5b4b",
  "LastCommitMessage": "Merge branch test into dev-update-version19",
  "LastCommitAuthor": "francesco.moroni",
  "LastCommitTime": "Wed Nov 4 17:42:28 2026 +0100",
  "VersionNumber": "22027"
}